import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import {
    applyDocumentLang,
    DEFAULT_LOCALE,
    loadStoredLocale,
    type AppLocale,
} from "i18n/locale";
import enCommon from "i18n/locales/en/common.json";
import enControl from "i18n/locales/en/control.json";
import enAuth from "i18n/locales/en/auth.json";
import enNavigation from "i18n/locales/en/navigation.json";
import enSettings from "i18n/locales/en/settings.json";
import enMissions from "i18n/locales/en/missions.json";
import zhHantCommon from "i18n/locales/zh-Hant/common.json";
import zhHantControl from "i18n/locales/zh-Hant/control.json";
import zhHantAuth from "i18n/locales/zh-Hant/auth.json";
import zhHantNavigation from "i18n/locales/zh-Hant/navigation.json";
import zhHantSettings from "i18n/locales/zh-Hant/settings.json";
import zhHantMissions from "i18n/locales/zh-Hant/missions.json";
import itCommon from "i18n/locales/it/common.json";
import itControl from "i18n/locales/it/control.json";
import itAuth from "i18n/locales/it/auth.json";
import itNavigation from "i18n/locales/it/navigation.json";
import itSettings from "i18n/locales/it/settings.json";
import itMissions from "i18n/locales/it/missions.json";
import jaCommon from "i18n/locales/ja/common.json";
import jaControl from "i18n/locales/ja/control.json";
import jaAuth from "i18n/locales/ja/auth.json";
import jaNavigation from "i18n/locales/ja/navigation.json";
import jaSettings from "i18n/locales/ja/settings.json";
import jaMissions from "i18n/locales/ja/missions.json";

const initialLocale = loadStoredLocale();
applyDocumentLang(initialLocale);

const MOMENT_LOCALE: Record<AppLocale, string> = {
    en: "en",
    "zh-Hant": "zh-tw",
    it: "it",
    ja: "ja",
};

export function momentLocaleForApp(locale: AppLocale): string {
    return MOMENT_LOCALE[locale] ?? "en";
}

i18n.use(initReactI18next).init({
    resources: {
        en: {
            common: enCommon,
            control: enControl,
            auth: enAuth,
            navigation: enNavigation,
            settings: enSettings,
            missions: enMissions,
        },
        "zh-Hant": {
            common: zhHantCommon,
            control: zhHantControl,
            auth: zhHantAuth,
            navigation: zhHantNavigation,
            settings: zhHantSettings,
            missions: zhHantMissions,
        },
        it: {
            common: itCommon,
            control: itControl,
            auth: itAuth,
            navigation: itNavigation,
            settings: itSettings,
            missions: itMissions,
        },
        ja: {
            common: jaCommon,
            control: jaControl,
            auth: jaAuth,
            navigation: jaNavigation,
            settings: jaSettings,
            missions: jaMissions,
        },
    },
    lng: initialLocale,
    fallbackLng: DEFAULT_LOCALE,
    defaultNS: "common",
    ns: ["common", "control", "auth", "navigation", "settings", "missions"],
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
